export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8656.4698e8da.jpg";